import React from "react";
import { selectors } from "@Src/redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import { Creators } from "@Src/redux/actionTypes";
import Loading from "@Components/loading";

const GetCategories = ({ children }) => {
  const [readyToContinue, setReadyToContinue] = React.useState(false);
  const isStandaloneTravel = useSelector(selectors.getIsStandaloneTravel);
  const dispatch = useDispatch();

  // Fetch Categories
  const getCats = React.useCallback(() => {
    dispatch(Creators.fetchingCategories());
  }, [dispatch]);

  // Fetch Categories
  React.useEffect(() => {
    if (!isStandaloneTravel && !readyToContinue) {
      setReadyToContinue(true);
      getCats();
    } else if (isStandaloneTravel && !readyToContinue) {
      setReadyToContinue(true);
    }
  }, [isStandaloneTravel, readyToContinue, getCats, setReadyToContinue]);

  if (!readyToContinue) {
    return <Loading />;
  }
  return children;
};

export default GetCategories;
